const Creating = () =>
{
    return (
        <div className={"container text-center mb-5"}>
            <h1 className="mb-5 text-white wow fadeInLeft">Make something great today with Replit!</h1>
            <button className="p-3 pe-4 ps-4 wow flipInX text-white box-shadow btn" style={{ "backgroundColor": "rgb(0, 83, 166)", "borderRadius": "10px", "boxShadow": "0 0 24px #0053A6" }}>Start creating</button>
        </div>
    );
}

export default Creating;